// A2-581 screen map lead 21: "N of these rows are dealt with under X"
// scrolled to a row of card X that existed only when X's rows were unfolded
// (X folds them past 10 rows, and an unopened card is not mounted at all),
// so the link often did nothing. The link now asks X to unfold its rows and
// scrolls to the row, or to X itself when the row is on a later page.
let pending = null;   // { flag, txnId }

export const revealRow = (flag, txnId) => {
  pending = { flag, txnId };
  window.dispatchEvent(new CustomEvent("rg-reveal-row", { detail: pending }));
  setTimeout(() => {
    const el = document.getElementById(`rgrow-${flag}-${txnId}`)
      || document.querySelector(`[data-testid="rg-group-${flag}"]`);
    if (el && el.scrollIntoView) el.scrollIntoView({ behavior: "smooth", block: "center" });
    pending = null;
  }, 120);
};

// For a card mounting now: was it asked to unfold?
export const revealPendingFor = (flag) => !!pending && pending.flag === flag;
